import "./ArtistModal.scss";
import "./SpotifyConnectModal.scss";

import { Button, Modal } from "react-bootstrap";
import { api } from "../../../utils/api";
import { useArtistContext } from "../ArtistPageContext";
import SpotifyConnect from "../../OnboardingPage/OnboardingSteps/SpotifyConnect";

export default function SpotifyConnectModal({ show, handleClose }) {
  const { artist, setArtist } = useArtistContext();

  const handleSpotifyConnected = async () => {
    const { data } = await api.get(`/profiles/display_name/${artist.display_name}`);
    setArtist(data);
    handleClose();
  };

  return (
    <Modal className="__artist-modal __spotify-connect-modal" show={ show } onHide={ handleClose } centered>
      <Modal.Header closeButton>
        <Modal.Title>Connect your Spotify account</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <SpotifyConnect handleNext={ handleSpotifyConnected } />
      </Modal.Body>

      <Modal.Footer>
        <Button className="ppy-btn ppy-btn-primary" onClick={ handleClose }>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
